export { default } from './AsgFooter'
export type { AsgFooterProps } from './types'
